class Cookie {
    constructor() {
        this.cookieBlock = document.querySelector('.footer__cookie');
        this.acceptBtn = this.cookieBlock.querySelector('button');
        this.init();
    }

    init() {
        this.getCookie();
        this.addCookie();
    }

    addCookie() {
        if (this.acceptBtn) {
            this.acceptBtn.addEventListener('click', ()=> {
                localStorage.setItem('cookie-accept', 'accepted');
                this.cookieBlock.classList.remove('_show');
            })
        }
    }

    getCookie() {
        if (localStorage.getItem('cookie-accept') === null) {
            this.cookieBlock.classList.add('_show');
        }
    }
}

document.addEventListener('DOMContentLoaded', function () {
    new Cookie()
})